export default __webpack_public_path__ + "static/img/header-background.9be98c1.jpg";